export const validationRules:any = {  
  local_supplier_name:{
      required: true,
  },
  category:  {
      "label": {
          required: true,
      },
  },  
  supplier_invoice_number:  {
      required: true,
  },
  supplier_invoice_date:  {
      required: true,
  },
  actual_invoice:  {
      required: true,
  },
  remark:  {
      required: true,
  },
}